
  
<main id="content" role="main" class="main bg-light">
  <!-- Content -->
  <div class="container py-20 py-sm-7">
    <div class="mx-auto" style="max-width: 30rem;">
      <!-- Card -->
      <div class="card card-lg mb-5 pt-5">
        <a class="d-flex justify-content-center mb-2" routerLink="/">
          <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 8rem;">
        </a>
        <div class="card-body">
          <!-- Form -->
          <div class="js-validate needs-validation" novalidate>
            <div class="text-center">
              <div class="mb-5" *ngIf="!showforget">
                <h1 class="display-5">
                  {{'RESET_PASSWORD' | translate}}
                </h1>
                <p [innerHTML]="'RESET_PASSWORD_INSTRUCTIONS' | translate"></p>
              </div>
              <div class="mb-5" *ngIf="showforget">
                <h1 class="display-5">
                  {{'VERIFY_OTP' | translate}}
                </h1>
                <p>
                  {{'ENTER_NEW_PASSWORD_OTP' | translate}}
                </p>
              </div>
            </div>

            <form [formGroup]="passForm" *ngIf="showforget" class="row g-3 mx-2 pt-8 mb-8">
              <div class="mb-2">
                <label for="otp" class="form-label">{{"otp" |translate}}</label>
                <input type="text" id="otp" class="form-control form-control-lg" formControlName="otp" [placeholder]="'otp' | translate">
                <div class="error-message text-danger"
                  *ngIf="userForm.get('otp')?.invalid && userForm.get('otp')?.touched">
                  <ng-container *ngIf="userForm.get('otp')?.hasError('required')">
                    {{'OTP_REQUIRED' | translate}}
                  </ng-container>
                  <ng-container *ngIf="userForm.get('otp')?.hasError('otp')">{{'INVALID_OTP_FORMAT' | translate}}</ng-container>
                </div>
              </div>
              <div class="mb-2">
                <label for="password" class="form-label">
                  {{'NEW_PASSWORD' | translate}}
                </label>
                <input type="password" id="password" class="form-control form-control-lg" formControlName="password" [placeholder]="'PASSWORD' | translate">
                <div class="error-message text-danger"
                  *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
                  <ng-container *ngIf="userForm.get('password')?.hasError('required')">
                    {{'PASSWORD_REQUIRED' | translate}}
                  </ng-container>
                  <ng-container *ngIf="userForm.get('password')?.hasError('password')">
                    {{'PASSWORD_VALIDATION' | translate}}
                  </ng-container>
                </div>
              </div>
              <div class="mb-2">
                <label for="email" class="form-label">
                  {{'EMAIL' | translate}}
                </label>
                <input type="email" id="email" class="form-control form-control-lg" formControlName="email" [placeholder]="'email_address' | translate">
                <div class="error-message text-danger"
                  *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
                  <ng-container *ngIf="userForm.get('email')?.hasError('required')">
                    {{'EMAIL_REQUIRED' | translate}}
                  </ng-container>
                  <ng-container *ngIf="userForm.get('email')?.hasError('email')">
                    {{'EMAIL_INVALID' | translate}}
                  </ng-container>
                </div>
              </div>
              <div class="d-grid mb-6" *ngIf="loading">
                <button type="button" class="btn btn-primary btn-lg rounded-2 mb-3 py-3 ms-2"> <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
              </div>
              <div class="d-grid mb-6" *ngIf="!loading">
                <button type="submit"  class="btn btn-primary btn-lg rounded-2 mb-3 py-3 ms-2" (click)="PassworRest()" >
                  {{'VERIFY_OTP' | translate}}
                </button>
              </div>
            </form>
            <form [formGroup]="userForm" (ngSubmit)="onSubmit()"  *ngIf="!showforget" class="row align-item-center pt-8">
                <div class="d-grid mb-2">
                <label for="Email" class="form-label">
                  {{'EMAIL' | translate}}
                </label>
                <input type="email" id="Email" class="form-control" formControlName="Email" [placeholder]="'email_address' | translate">
                <div class="error-message text-danger"
                  *ngIf="userForm.get('Email')?.invalid && userForm.get('Email')?.touched">
                  <ng-container *ngIf="userForm.get('Email')?.hasError('required')">
                    {{'EMAIL_REQUIRED' | translate}}
                  </ng-container>
                  <ng-container *ngIf="userForm.get('Email')?.hasError('Email')">
                    {{'EMAIL_INVALID' | translate}}
                  </ng-container>
                </div>
              </div>
              <div class="d-grid" *ngIf="loading">
                <button type="button" class="btn btn-primary btn-lg rounded-2 mb-3 py-3 ">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
              </div>
              <div class="d-grid " *ngIf="!loading">
                <button type="submit" class="btn btn-primary btn-lg rounded-2 mb-3 py-3 " [disabled]="userForm.invalid" style="background-color: rgb(80,34,116) !important;" >
                  {{'SUBMIT' | translate}}
                </button>
              </div>
    
    
            </form>
          </div>
          <!-- End Form -->
        </div>
      </div>
      <!-- End Card -->

    
    </div>
  </div>
  <!-- End Content -->
</main>